import { put, select, takeLatest } from 'redux-saga/effects'
import { VitalsConstants } from '../store/vitals.constants'
import { getPatientVitalsSelector } from '../selectors/patientVitals.selector'
import { initialVitalsState } from '../store/vitals.reducers'
import { compareObjectsIfEqual, filterOutObjectKeys } from '../../../utilities/object.util'
import { showToast } from '../../../components/toast/store/toast.actions'
import { ToastColor } from '../../../components/toast/store/toast.constants'
import { resetPatientVitalsState } from '../store/vitals.actions'
import i18n from '../../../i18n'
import { IPatientVitals } from '../store/vitals.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { TabConstants } from '../../../components/tabs/Tabs.constants'

const hasStateChanged = (vitalsState: IPatientVitals) => {
  const fieldsToFilter = [
    'key',
    'addToTimeline',
    'temperatureType',
    'showRepeatVitals',
    'reRunValidations',
    '__isRedirectedFrom',
    'customVitalLabel1',
    'customVitalLabel2',
    '__customVitalLabelExists',
  ]
  const currentState = filterOutObjectKeys(vitalsState, fieldsToFilter)
  const initalState = filterOutObjectKeys(initialVitalsState, fieldsToFilter)
  if (!compareObjectsIfEqual(currentState, initalState)) {
    return true
  }
  return false
}

export function* checkQuickActionsRedirectSaga() {
  try {
    const vitalsState: IPatientVitals = yield select(getPatientVitalsSelector)
    const hasUserInteracted = hasStateChanged(vitalsState)
    const { __isRedirectedFrom } = vitalsState

    const isRedirectedFromQuickActions = __isRedirectedFrom === TabConstants.QUICK_ACTIONS_TAB

    if (isRedirectedFromQuickActions && hasUserInteracted) {
      yield put(
        showToast({
          message: i18n.t('quickActions.VitalsAddedToastLabel'),
          position: 'top',
          color: ToastColor.Success,
        })
      )
    }
    yield put(resetPatientVitalsState())
  } catch (error) {
    yield put(throwPcrException(`checkQuickActionsRedirectSaga() error: ${error}`))
  }
}

export function* checkQuickActionsRedirectSagaWatcher() {
  yield takeLatest(VitalsConstants.CHECK_QUICK_ACTIONS_REDIRECT, performWithMutexHOG, checkQuickActionsRedirectSaga)
}
